import script from "./ConfigEditorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigEditorModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigEditorModal.vue?vue&type=style&index=0&id=2f0c4077&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0c4077"]])

export default __exports__